"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIND = void 0;
exports.FIND = {
    alias: 'LOCALIZAR',
    description: 'Localiza uma string de texto dentro de uma segunda string de texto e retorna o número da posição inicial da primeira string de texto do primeiro caractere da segunda string de texto. Opcionalmente, você pode especificar qual ocorrência você quer encontrar.',
    arg_names: ['texto_a_localizar', 'texto', 'numero_comeco', 'ocorrencia'],
    args_description: [
        'O texto que você deseja encontrar',
        'O texto que contém o texto que você deseja encontrar',
        'Especifica o caractere no qual iniciar a pesquisa',
        'Especifica qual ocorrência do texto a localizar você deseja encontrar. Se omitido, será retornada a primeira ocorrência',
    ],
};
